import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { InfoTooltip } from 'components';
import { DNSIcon } from 'components/CustomSVG';
import { Card, Grid, Icon, Typography } from '@material-ui/core';


function ReCaptchaIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 41 41" fill="none">
      <path d="M1.5447 12.0201C-0.164742 16.1084 0.0467422 20.0583 0.0467422 20.0583H9.35147C9.35147 20.0583 9.9787 17.0753 10.9702 15.4627C11.8352 14.0558 13.8672 12.5716 13.8672 12.5716L18.6708 17.4242V0.991436H2.79784L6.76609 5.5132C6.76609 5.5132 3.25415 7.93187 1.5447 12.0201Z" fill="#1C3AA9" />
      <path d="M29.0321 2.6991C24.9521 0.986186 21.0102 1.1981 21.0102 1.1981L21.0102 10.5217C21.0102 10.5217 23.9871 11.1502 25.5964 12.1437C27.0005 13.0104 28.4817 15.0466 28.4817 15.0466L23.6389 19.86L40.0384 19.86L40.0384 3.95477L35.5258 7.93107C35.5258 7.93107 33.112 4.41201 29.0321 2.6991Z" fill="#1C3AA9" />
      <path d="M19.5059 40.9914C27.605 40.9914 32.4361 36.4266 32.4361 36.4266L27.0892 27.515C27.0892 27.515 24.4685 31.5225 19.5059 31.5225C14.5433 31.5225 11.4067 27.515 11.4067 27.515L15.652 22.4418L0.0923138 22.4418L0.0923155 39.2054L4.37385 35.0145C4.37385 35.0145 11.4067 40.9914 19.5059 40.9914Z" fill="#1C3AA9" />
    </svg>
  );
}

const GoLiveConfigs = () => {
  const {profile} = useSelector((state: IReduxState) => state.user);
  const permissions = profile?.config?.permissions || {};

  return (
    <div className="p-8">
      <Grid container spacing={3} className="text-center">
        {/* {permissions?.settingsStripe &&
          <Grid item xs={12} sm={3} md={2} className="relative">
            <Button onClick={handleClickStripe} className="p-0">
              <Card  className="p-10 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">payment</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Configure STRIPE account</Typography>
              </Card>
            </Button>
            <InfoTooltip
              classNames="text-error absolute text-24"
              style={{position: 'absolute', right: '25px', top: '25px'}}
              title="Need to be filled in before store goes live."
            />
          </Grid>
        } */}
        {permissions?.settingsTaxRates &&
          <Grid item xs={12} sm={3} md={2} className="relative">
            <Link to="/configurations/tax-rates">
              <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                <Icon className="text-40" color="primary">rate_review</Icon>
                <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Tax Rates</Typography>
              </Card>
            </Link>
            <InfoTooltip
              classNames="text-error absolute text-24"
              style={{position: 'absolute', right: '25px', top: '25px'}}
              title="Need to be filled in before store goes live."
            />
          </Grid>
        }
        {permissions?.settingsDNS &&
        <Grid item xs={12} sm={3} md={2} className="relative" >
          <Link to="/configurations/dns">
            <Card
              className="py-8 light-blue-on-hover h-full flex-column justify-center items-center"
              elevation={8}
              title="Click here to install the following records to connect your online store."
            >
              <DNSIcon />
              <Typography variant="h5" className="mt-4 min-h-50 max-w-120" color="primary">
                Connect Your Store Domain
              </Typography>
            </Card>
          </Link>
          <InfoTooltip
            classNames="text-error absolute text-24"
            style={{position: 'absolute', right: '25px', top: '25px'}}
            title="Need to be filled in before store goes live."
          />
        </Grid>
        }
        {permissions?.settingsRecaptcha &&
        <Grid item xs={12} sm={3} md={2} className="relative">
          <Link to="/configurations/recaptcha">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center relative" elevation={8} title="Click here to get your Site Key and Secret Key">
              <ReCaptchaIcon />
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">reCAPTCHA</Typography>
            </Card>
          </Link>
          <InfoTooltip
            classNames="text-error absolute text-24"
            style={{position: 'absolute', right: '25px', top: '25px'}}
            title="Need to be filled in before store goes live."
          />
        </Grid>
        }
        {/* {permissions?.settingsPaymentMethods &&
        <Grid item xs={12} sm={3} md={2}>
          <Link to="/configurations/bluepay">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center relative" elevation={8}>
              <Icon className="text-40" color="primary">payment</Icon>
              <InfoTooltip
                classNames="text-error absolute text-24"
                style={{position: 'absolute', right: '10px', top: '10px'}}
                title="Need to be filled in before store goes live."
              />
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Application For Merchant Id</Typography>
            </Card>
          </Link>
        </Grid>
        } */}
        {permissions?.settingsUserPlans &&
        <Grid item xs={12} sm={3} md={2} className="relative">
          <Link to="/configurations/plans">
            <Card  className="py-8 light-blue-on-hover h-full flex-column justify-center items-center relative" elevation={8}>
              <Icon className="text-40" color="primary">receipt</Icon>
              <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Payment Options</Typography>
            </Card>
          </Link>
          <InfoTooltip
            classNames="text-error absolute text-24"
            style={{position: 'absolute', right: '25px', top: '25px'}}
            title="Need to be filled in before store goes live."
          />
        </Grid>
        }
        <Grid item xs={12} sm={3} md={2} className="relative">
          <Link to="/configurations/store-emails">
            <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">alternate_email</Icon>
              <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Store Emails</Typography>
            </Card>
          </Link>
          <InfoTooltip
            classNames="text-error absolute text-24"
            style={{position: 'absolute', right: '25px', top: '25px'}}
            title="Need to be filled in before store goes live."
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2} className="relative">
          <Link to="/configurations/default-customer-group">
            <Card  className="p-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
              <Icon className="text-40" color="primary">group_alt</Icon>
              <Typography variant="h5" color="primary" className="mt-4 max-w-150 min-h-50">Default Customer Group</Typography>
            </Card>
          </Link>
          <InfoTooltip
            classNames="text-error absolute text-24"
            style={{position: 'absolute', right: '25px', top: '25px'}}
            title="Need to be filled in before store goes live."
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default GoLiveConfigs;
